import { render, staticRenderFns } from "./alert-new-version.vue?vue&type=template&id=febb5b2e&scoped=true&"
import script from "./alert-new-version.vue?vue&type=script&lang=js&"
export * from "./alert-new-version.vue?vue&type=script&lang=js&"
import style0 from "./alert-new-version.vue?vue&type=style&index=0&id=febb5b2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febb5b2e",
  null
  
)

export default component.exports